import { useState, useCallback } from "react";
import { FilterValues } from "@/types/filters";

export function useFilters<T extends FilterValues>(initialFilters: T = {} as T) {
  const [filters, setFilters] = useState<T>(initialFilters);

  const updateFilters = useCallback((newFilters: Partial<T>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({} as T);
  }, []);

  const getActiveFilterCount = useCallback(() => {
    return Object.values(filters).filter(
      (value) => value !== "" && value !== undefined && value !== null,
    ).length;
  }, [filters]);

  const hasActiveFilters = useCallback(() => {
    return getActiveFilterCount() > 0;
  }, [getActiveFilterCount]);

  return {
    filters,
    updateFilters,
    clearFilters,
    getActiveFilterCount,
    hasActiveFilters,
    setFilters,
  };
}

export default useFilters;